function objectsAreDifferent(obj1, obj2) {
  return Object.keys(obj1).some(
    (key) =>
      JSON.stringify(JSON.parse(JSON.stringify(obj1[key]))) !==
      JSON.stringify(JSON.parse(JSON.stringify(obj2[key])))
  );
}

export { objectsAreDifferent };
